export const mypageTabs = [
  { id: 'myInfo', label: '내 정보' },
  { id: 'orderList', label: '주문 내역' },
  { id: 'myReview', label: '리뷰 관리' },
];

export const mypageReviewTabs = [
  { id: 'myReviewWrite', label: '리뷰 작성' },
  { id: 'completedReview', label: '작성한 리뷰' },
];

export const mypageOrderTabs = [
  { id: 'all', label: '전체' },
  { id: 'pendingPayment', label: '결제 대기' },
  { id: 'processing', label: '배송 준비' },
  { id: 'shipped', label: '배송 중' },
  { id: 'delivered', label: '배송 완료' },
  { id: 'cancelled', label: '취소/환불' },
];
